import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import SimpleBar from 'simplebar-react';
import IconoFace from '../../assets/images/icons/face.png'
import EmployeeLogo from '../../assets/images/logos/EmployeeCenterLogo.png'
import EmployeeLogoMini from '../../assets/images/logos/EmployeeCenterLogoMini.png'
import {
  Navbar,
  Nav,
  NavItem,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from 'reactstrap';
import * as Icon from 'react-feather';
import { ReactComponent as LogoWhite } from '../../assets/images/logos/white-logo-icon.svg';
import MessageDD from './MessageDD';
import NotificationDD from './NotificationDD';
import MegaDD from './MegaDD';
import user1 from '../../assets/images/users/user4.jpg';
import Logo from '../logo/Logo';
import { ToggleMiniSidebar, ToggleMobileSidebar } from '../../store/customizer/CustomizerSlice';
import ProfileDD from './ProfileDD';
import { useAuth } from '../../components/context/AuthContext';
import { useMsal } from '@azure/msal-react';

const Header = ({ userPhoto }) => {
  const navigate = useNavigate();
  const isDarkMode = useSelector((state) => state.customizer.isDark);
  const topbarColor = useSelector((state) => state.customizer.topbarBg);
  const { logout } = useAuth();
  const dispatch = useDispatch();

  const { instance } = useMsal();

  const handleMicrosoftLogOut = async () => {
    try {
      await instance.logoutPopup();
      logout();
      navigate('/auth/login');
    } catch (e) {
      console.error('Error en el logout:', e);
    }
  };

  return (
    <>
      <Navbar
        color={topbarColor}
        dark={!isDarkMode}
        light={isDarkMode}
        expand="lg"
        className="topbar"
      >
        {/********Logo*******/}
        <div className="d-none d-lg-flex align-items-center logo-space">
          <img
                  src={EmployeeLogo}
                  alt="profile" width="130"
                />
          <span className="d-sm-block d-lg-none">
            <Button
              close
              size="sm"
              className="ms-auto"
              onClick={() => dispatch(ToggleMobileSidebar())}
            />
          </span>
        </div>
        {/******************************/}
        {/**********Toggle Buttons**********/}
        {/******************************/}
        <div className="d-flex align-items-center">
          <Button
            color={topbarColor}
            className="d-none d-lg-block mx-1 bg-transparent border-0"
            onClick={() => dispatch(ToggleMiniSidebar())}
          >
            <Icon.Menu size={18} />
          </Button>
          <NavbarBrand href="/" className="d-sm-block d-lg-none">
          <img
                  src={EmployeeLogoMini}
                  alt="profile" className="rounded-circle" width="30"
                />
          </NavbarBrand>
          <Button
            color={topbarColor}
            className="d-sm-block d-lg-none bg-transparent border-0 mx-1"
            onClick={() => dispatch(ToggleMobileSidebar())}
          >
            <i className="bi bi-list" />
          </Button>
        </div>

        {/******************************/}
        {/**********Left Nav Bar**********/}
        {/******************************/}

        <Nav className="me-auto d-flex flex-row align-items-center" navbar>
          {/******************************/}
          {/**********Mega DD**********/}
          {/******************************/}
          {/* <UncontrolledDropdown className="mega-dropdown mx-1">
            <DropdownToggle className="bg-transparent border-0" color={topbarColor}>
              <Icon.Grid size={18} />
            </DropdownToggle>
            <DropdownMenu>
              <MegaDD />
            </DropdownMenu>
          </UncontrolledDropdown>
          <NavItem className="d-md-block d-none">
            <Link to="/about" className={`nav-link ${topbarColor === 'white' ? 'text-dark' : ''}`}>
              About 2
            </Link>
          </NavItem> */}
        </Nav>

        <div className="d-flex align-items-center">
          {/******************************/}
          {/**********Notification DD**********/}
          {/******************************/}
          {/* <UncontrolledDropdown className="mx-1">
            <DropdownToggle className="bg-transparent border-0" color={topbarColor}>
              <Icon.MessageSquare size={18} />
            </DropdownToggle>
            <DropdownMenu className="ddWidth">
              <DropdownItem header>
                <span className="mb-0 fs-5">Notifications</span>
              </DropdownItem>
              <DropdownItem divider />
              <SimpleBar style={{ maxHeight: '350px' }}>
                <NotificationDD />
              </SimpleBar>
              <DropdownItem divider />
              <div className="p-2 px-3">
                <Button color="primary" size="sm" block>
                  Check All
                </Button>
              </div>
            </DropdownMenu>
          </UncontrolledDropdown> */}
          {/******************************/}
          {/**********Message DD**********/}
          {/******************************/}
          {/* <UncontrolledDropdown className="mx-1">
            <DropdownToggle className="bg-transparent border-0" color={topbarColor}>
              <Icon.Mail size={18} />
            </DropdownToggle>
            <DropdownMenu className="ddWidth">
              <DropdownItem header>
                <span className="mb-0 fs-5">Messages</span>
              </DropdownItem>
              <DropdownItem divider />
              <SimpleBar style={{ maxHeight: '350px' }}>
                <MessageDD />
              </SimpleBar>
              <DropdownItem divider />
              <div className="p-2 px-3">
                <Button color="primary" size="sm" block>
                  Check All
                </Button>
              </div>
            </DropdownMenu>
          </UncontrolledDropdown> */}
          {/******************************/}
          {/**********Profile DD**********/}
          {/******************************/}
          <UncontrolledDropdown>
            <DropdownToggle color="transparent">
              {userPhoto ? (
                <img
                  src={userPhoto}
                  alt="profile" className="rounded-circle" width="30"
                />
              ) : (
                <img
                  src={IconoFace}
                  alt="profile" className="rounded-circle" width="30"
                />
              )}
            </DropdownToggle>
            <DropdownMenu className="ddWidth profile-dd">
              <ProfileDD userPhoto={userPhoto} />
              <div className="p-2 px-3">
                <Button color="danger" size="sm" onClick={handleMicrosoftLogOut}>
                  Cerrar Sesion
                </Button>
              </div>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </Navbar>
    </>
  );
};

export default Header;
